<template>
  <div>
    <el-collapse v-loading="loading" value="3">
      <el-collapse-item name="3">
        <template #title>
          <div style="margin-left: 7px;">
          <i class="fa-solid fa-bars-staggered"></i>
          &nbsp;
          <span>{{$t('Əməliyyatlar')}}</span>
          </div>
        </template>
        <card style="margin-bottom: 0px;">
          <div class="row">
            <div class="col-12 " style="padding-bottom: 10px;">
              <el-button size="small" style="margin-right: 15px;" type="primary" v-if="!readonly"
                @click="NewAssessment">
                <i class="fa-solid fa-car"></i> {{$t('Yeni_əməliyyat')}}
              </el-button>
            </div>
          </div>
          <br>
          <div class="row">
            <div class="col-12">
              <el-timeline class="custom-timeline">
                <el-timeline-item :color="itemColor(item.status)" v-for="(item, index) in filteredData" :key="index"
                  :timestamp="formatDateTime(item.createDate)" :size="'normal'" placement="top">
                  <el-card class="custom-card">
                    <div class="row">
                      <div class="col-md-10">
                        <div class="row">
                          <div :class="['col-2 ', textLeft, ' pd']">{{$t('Status')}}:</div>
                          <div class="col-10 pd">
                            {{ item.statusName }}
                            <span
                              v-if="(item.status === 1 && item.offeredAmount) || (item.status === 4 && item.agreedAmount)"
                              style="font-weight: bold;">
                              - {{ item.status === 1 ? item.offeredAmount : item.agreedAmount }} man.
                            </span>
                          </div>
                          <div :class="['col-2 ', textLeft, ' pd']">{{$t('Daxil_olunub')}}:</div>
                          <div class="col-10 pd">
                            {{ item.createUserName }}
                          </div>
                          <div :class="['col-2 ', textLeft, ' pd']">{{$t('Qeyd')}}:</div>
                          <div class="col-10 pd">
                            {{ item.note }}
                          </div>
                        </div>
                      </div>
                      <div class="col-md-2" v-if="!readonly">
                        <div :class="['', textRight, '']">
                          <el-dropdown trigger="click" @command="handleCommand">
                            <el-button type="text" class="custom-button" style="padding: 0 0 0 0 !important;">
                              <div class="square-icon">
                                <i class="fas fa-ellipsis-h" style="color: #808080;"></i>
                              </div>
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                              <el-dropdown-item :command="{ action: 'edit', id: item.id }">
                                <i class="fa-solid fa-pen-to-square"></i>{{$t('Düzəliş')}}
                              </el-dropdown-item>
                              <el-dropdown-item :command="{ action: 'delete', id: item.id }">
                                <i class="fa-solid fa-trash-can"></i>{{$t('Ləğv_et')}}
                              </el-dropdown-item>
                            </el-dropdown-menu>
                          </el-dropdown>
                        </div>
                      </div>
                    </div>
                  </el-card>
                </el-timeline-item>
              </el-timeline>
            </div>
          </div>
        </card>
      </el-collapse-item>
    </el-collapse>
    <assessment-modal ref="assessment" @saved="saved" />
  </div>
</template>


<script>
  import {
    DeleteAssessment,
    GetDamageAssessments
  } from "src/services/claim";
  import AssessmentModal from "./AssessmentModal.vue";
  import { textRight,textLeft,formatDateTime, labelPosition } from "../../services/helper";

  export default {
    computed: {
      filteredData() {
        return this.data.filter(
          (data) =>
            !this.search ||
            data.claimId.toLowerCase().includes(this.search.toLowerCase())
        );
      },
      itemColor() {
        return (status) => {
          switch (status) {
            case 1:
              return 'brown';
            case 2:
              return 'turquoise';
            case 3:
              return 'yellow';
            case 4:
              return 'green';
            case 5:
              return 'yellow';
            case 6:
              return 'lawngreen';
            case 7:
              return 'coral';
            default:
              return 'grey';
          }
        };
      },
    },
    components: {
      AssessmentModal,
    },
    props: {
      claimId: { type: Number, default: 0 },
      readonly: { type: Boolean, default: false },
    },
    data() {
      return {
        loading: false,
        data: [],
        search: "",
        assessment: {},
        uid: this.$store.state.user.id,
        textRight: textRight,
        textLeft: textLeft,
        labelPosition: labelPosition,
      };
    },
    methods: {
      formatDateTime,
      NewAssessment() {
        this.$refs["assessment"].new(this.claimId);
      },

      saved() {
        // if (value.action === "new") {
        //   this.handleComm(value.id);
        // }
        this.getData();
      },
      handleCommand(command) {
        let id = command.id;
        if (command.action === 'edit') {
          this.handleEdit(id);
        } else if (command.action === 'delete') {
          this.handleDelete(id);
        }
      },
      handleEdit(id) {
        this.$refs["assessment"].edit(id);
      },
      handleDelete(id) {
        this.$confirm("Hadisə ləğv olunsun?", "Təsdiqləyin", {
          cancelButtonText: this.$t('Xeyr'),
          confirmButtonText: this.$t('Bəli'),
          type: "error",
        })
          .then(() => {
            this.loading = true;
            DeleteAssessment(id, this.uid).then((response) => {
              this.loading = false;
              if (response.data.data) {
                if (!response.data.isSuccess) {
                  this.$message({
                    type: "error",
                    message: response.data.errors[0],
                  });
                } else {
                  this.$message({
                    type: "success",
                    message: "Ləğv olundu",
                  });
                  this.getData();

                  this.$emit("refresh");
                }
              } else {
                this.getData();
                this.$message({
                  type: "error",
                  message: "Səhv əməliyyat",
                });
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "Xitam verildi",
            });
          });
      },

      getData() {
        this.loading = true;
        GetDamageAssessments(this.claimId).then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.data = response.data.data;

            this.$emit("refresh");
          }
          else {
            this.data = []
          }
        });
      },
    },
    mounted() {
      this.getData();
    },

  };

</script>

<style lang="css" scoped>
  .md-card .md-card-actions {
    border: 0;
    margin-left: 20px;
    margin-right: 20px;
  }

  .custom-card h4 {
    margin-top: 0;
    /* Üst boşluğu sıfırla */
    margin-bottom: 5px;
    /* Alt boşluğu azalt */
  }

  .custom-card p {
    margin-top: 0;
    /* Üst boşluğu sıfırla */
    margin-bottom: 5px;
    /* Alt boşluğu azalt */
  }

  .custom-timeline {
    position: relative;
    right: 35px;
  }
</style>